/******/
(function () {
  // webpackBootstrap

  /******/
  var __webpack_modules__ = {
    /***/
    366:
    /***/
    function (module) {
      function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
      }

      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }

      function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
      }

      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
      }

      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      }

      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);

        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          })), keys.push.apply(keys, symbols);
        }

        return keys;
      }

      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = null != arguments[i] ? arguments[i] : {};
          i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }

        return target;
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }
      /*
       * Copyright (C) 2019 HERE Europe B.V.
       * Licensed under MIT, see full license in LICENSE
       * SPDX-License-Identifier: MIT
       * License-Filename: LICENSE
       */


      var DEFAULT_PRECISION = 5;
      var ENCODING_TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
      var DECODING_TABLE = [62, -1, -1, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, 63, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
      var FORMAT_VERSION = 1;
      var ABSENT = 0;
      var LEVEL = 1;
      var ALTITUDE = 2;
      var ELEVATION = 3; // Reserved values 4 and 5 should not be selectable

      var CUSTOM1 = 6;
      var CUSTOM2 = 7;
      var Num = typeof BigInt !== "undefined" ? BigInt : Number;

      function decode(encoded) {
        var decoder = decodeUnsignedValues(encoded);
        var header = decodeHeader(decoder[0], decoder[1]);
        var factorDegree = Math.pow(10, header.precision);
        var factorZ = Math.pow(10, header.thirdDimPrecision);
        var thirdDim = header.thirdDim;
        var lastLat = 0;
        var lastLng = 0;
        var lastZ = 0;
        var res = [];
        var i = 2;

        for (; i < decoder.length;) {
          var deltaLat = toSigned(decoder[i]) / factorDegree;
          var deltaLng = toSigned(decoder[i + 1]) / factorDegree;
          lastLat += deltaLat;
          lastLng += deltaLng;

          if (thirdDim) {
            var deltaZ = toSigned(decoder[i + 2]) / factorZ;
            lastZ += deltaZ;
            res.push([lastLat, lastLng, lastZ]);
            i += 3;
          } else {
            res.push([lastLat, lastLng]);
            i += 2;
          }
        }

        if (i !== decoder.length) {
          throw new Error('Invalid encoding. Premature ending reached');
        }

        return _objectSpread(_objectSpread({}, header), {}, {
          polyline: res
        });
      }

      function decodeChar(_char) {
        var charCode = _char.charCodeAt(0);

        return DECODING_TABLE[charCode - 45];
      }

      function decodeUnsignedValues(encoded) {
        var result = Num(0);
        var shift = Num(0);
        var resList = [];
        encoded.split('').forEach(function (_char2) {
          var value = Num(decodeChar(_char2));
          result |= (value & Num(0x1F)) << shift;

          if ((value & Num(0x20)) === Num(0)) {
            resList.push(result);
            result = Num(0);
            shift = Num(0);
          } else {
            shift += Num(5);
          }
        });

        if (shift > 0) {
          throw new Error('Invalid encoding');
        }

        return resList;
      }

      function decodeHeader(version, encodedHeader) {
        if (+version.toString() !== FORMAT_VERSION) {
          throw new Error('Invalid format version');
        }

        var headerNumber = +encodedHeader.toString();
        var precision = headerNumber & 15;
        var thirdDim = headerNumber >> 4 & 7;
        var thirdDimPrecision = headerNumber >> 7 & 15;
        return {
          precision: precision,
          thirdDim: thirdDim,
          thirdDimPrecision: thirdDimPrecision
        };
      }

      function toSigned(val) {
        // Decode the sign from an unsigned value
        var res = val;

        if (res & Num(1)) {
          res = ~res;
        }

        res >>= Num(1);
        return +res.toString();
      }

      function encode(_ref) {
        var _ref$precision = _ref.precision,
            precision = _ref$precision === void 0 ? DEFAULT_PRECISION : _ref$precision,
            _ref$thirdDim = _ref.thirdDim,
            thirdDim = _ref$thirdDim === void 0 ? ABSENT : _ref$thirdDim,
            _ref$thirdDimPrecisio = _ref.thirdDimPrecision,
            thirdDimPrecision = _ref$thirdDimPrecisio === void 0 ? 0 : _ref$thirdDimPrecisio,
            polyline = _ref.polyline; // Encode a sequence of lat,lng or lat,lng(,{third_dim}). Note that values should be of type BigNumber
        //   `precision`: how many decimal digits of precision to store the latitude and longitude.
        //   `third_dim`: type of the third dimension if present in the input.
        //   `third_dim_precision`: how many decimal digits of precision to store the third dimension.

        var multiplierDegree = Math.pow(10, precision);
        var multiplierZ = Math.pow(10, thirdDimPrecision);
        var encodedHeaderList = encodeHeader(precision, thirdDim, thirdDimPrecision);
        var encodedCoords = [];
        var lastLat = Num(0);
        var lastLng = Num(0);
        var lastZ = Num(0);
        polyline.forEach(function (location) {
          var lat = Num(Math.round(location[0] * multiplierDegree));
          encodedCoords.push(encodeScaledValue(lat - lastLat));
          lastLat = lat;
          var lng = Num(Math.round(location[1] * multiplierDegree));
          encodedCoords.push(encodeScaledValue(lng - lastLng));
          lastLng = lng;

          if (thirdDim) {
            var z = Num(Math.round(location[2] * multiplierZ));
            encodedCoords.push(encodeScaledValue(z - lastZ));
            lastZ = z;
          }
        });
        return [].concat(_toConsumableArray(encodedHeaderList), encodedCoords).join('');
      }

      function encodeHeader(precision, thirdDim, thirdDimPrecision) {
        // Encode the `precision`, `third_dim` and `third_dim_precision` into one encoded char
        if (precision < 0 || precision > 15) {
          throw new Error('precision out of range. Should be between 0 and 15');
        }

        if (thirdDimPrecision < 0 || thirdDimPrecision > 15) {
          throw new Error('thirdDimPrecision out of range. Should be between 0 and 15');
        }

        if (thirdDim < 0 || thirdDim > 7 || thirdDim === 4 || thirdDim === 5) {
          throw new Error('thirdDim should be between 0, 1, 2, 3, 6 or 7');
        }

        var res = thirdDimPrecision << 7 | thirdDim << 4 | precision;
        return encodeUnsignedNumber(FORMAT_VERSION) + encodeUnsignedNumber(res);
      }

      function encodeUnsignedNumber(val) {
        // Uses variable integer encoding to encode an unsigned integer. Returns the encoded string.
        var res = '';
        var numVal = Num(val);

        while (numVal > 0x1F) {
          var pos = numVal & Num(0x1F) | Num(0x20);
          res += ENCODING_TABLE[pos];
          numVal >>= Num(5);
        }

        return res + ENCODING_TABLE[numVal];
      }

      function encodeScaledValue(value) {
        // Transform a integer `value` into a variable length sequence of characters.
        //   `appender` is a callable where the produced chars will land to
        var numVal = Num(value);
        var negative = numVal < 0;
        numVal <<= Num(1);

        if (negative) {
          numVal = ~numVal;
        }

        return encodeUnsignedNumber(numVal);
      }

      module.exports = {
        encode: encode,
        decode: decode,
        ABSENT: ABSENT,
        LEVEL: LEVEL,
        ALTITUDE: ALTITUDE,
        ELEVATION: ELEVATION
      };
      /***/
    },

    /***/
    716:
    /***/
    function (module) {
      function corslite(url, callback, cors) {
        var sent = false;

        if (typeof window.XMLHttpRequest === 'undefined') {
          return callback(Error('Browser not supported'));
        }

        if (typeof cors === 'undefined') {
          var m = url.match(/^\s*https?:\/\/[^\/]*/);
          cors = m && m[0] !== location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        }

        var x = new window.XMLHttpRequest();

        function isSuccessful(status) {
          return status >= 200 && status < 300 || status === 304;
        }

        if (cors && !('withCredentials' in x)) {
          // IE8-9
          x = new window.XDomainRequest(); // Ensure callback is never called synchronously, i.e., before
          // x.send() returns (this has been observed in the wild).
          // See https://github.com/mapbox/mapbox.js/issues/472

          var original = callback;

          callback = function callback() {
            if (sent) {
              original.apply(this, arguments);
            } else {
              var that = this,
                  args = arguments;
              setTimeout(function () {
                original.apply(that, args);
              }, 0);
            }
          };
        }

        function loaded() {
          if ( // XDomainRequest
          x.status === undefined || // modern browsers
          isSuccessful(x.status)) callback.call(x, null, x);else callback.call(x, x, null);
        } // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
        // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).


        if ('onload' in x) {
          x.onload = loaded;
        } else {
          x.onreadystatechange = function readystate() {
            if (x.readyState === 4) {
              loaded();
            }
          };
        } // Call the callback with the XMLHttpRequest object as an error and prevent
        // it from ever being called again by reassigning it to `noop`


        x.onerror = function error(evt) {
          // XDomainRequest provides no evt parameter
          callback.call(this, evt || true, null);

          callback = function callback() {};
        }; // IE9 must have onprogress be set to a unique function.


        x.onprogress = function () {};

        x.ontimeout = function (evt) {
          callback.call(this, evt, null);

          callback = function callback() {};
        };

        x.onabort = function (evt) {
          callback.call(this, evt, null);

          callback = function callback() {};
        }; // GET is the only supported HTTP Verb by XDomainRequest and is the
        // only one supported here.


        x.open('GET', url, true); // Send the request. Sending data is not supported.

        x.send(null);
        sent = true;
        return x;
      }

      if (true) module.exports = corslite;
      /***/
    },

    /***/
    36:
    /***/
    function (module) {
      "use strict";

      function _typeof(obj) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
      }

      var isMergeableObject = function isMergeableObject(value) {
        return isNonNullObject(value) && !isSpecial(value);
      };

      function isNonNullObject(value) {
        return !!value && _typeof(value) === 'object';
      }

      function isSpecial(value) {
        var stringValue = Object.prototype.toString.call(value);
        return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
      } // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


      var canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;

      function isReactElement(value) {
        return value.$$typeof === REACT_ELEMENT_TYPE;
      }

      function emptyTarget(val) {
        return Array.isArray(val) ? [] : {};
      }

      function cloneUnlessOtherwiseSpecified(value, options) {
        return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
      }

      function defaultArrayMerge(target, source, options) {
        return target.concat(source).map(function (element) {
          return cloneUnlessOtherwiseSpecified(element, options);
        });
      }

      function getMergeFunction(key, options) {
        if (!options.customMerge) {
          return deepmerge;
        }

        var customMerge = options.customMerge(key);
        return typeof customMerge === 'function' ? customMerge : deepmerge;
      }

      function getEnumerableOwnPropertySymbols(target) {
        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
          return target.propertyIsEnumerable(symbol);
        }) : [];
      }

      function getKeys(target) {
        return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
      }

      function propertyIsOnObject(object, property) {
        try {
          return property in object;
        } catch (_) {
          return false;
        }
      } // Protects from prototype poisoning and unexpected merging up the prototype chain.


      function propertyIsUnsafe(target, key) {
        return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
        && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
        && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
      }

      function mergeObject(target, source, options) {
        var destination = {};

        if (options.isMergeableObject(target)) {
          getKeys(target).forEach(function (key) {
            destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
          });
        }

        getKeys(source).forEach(function (key) {
          if (propertyIsUnsafe(target, key)) {
            return;
          }

          if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
            destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
          } else {
            destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
          }
        });
        return destination;
      }

      function deepmerge(target, source, options) {
        options = options || {};
        options.arrayMerge = options.arrayMerge || defaultArrayMerge;
        options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
        // implementations can use it. The caller may not replace it.

        options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
        var sourceIsArray = Array.isArray(source);
        var targetIsArray = Array.isArray(target);
        var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

        if (!sourceAndTargetTypesMatch) {
          return cloneUnlessOtherwiseSpecified(source, options);
        } else if (sourceIsArray) {
          return options.arrayMerge(target, source, options);
        } else {
          return mergeObject(target, source, options);
        }
      }

      deepmerge.all = function deepmergeAll(array, options) {
        if (!Array.isArray(array)) {
          throw new Error('first argument should be an array');
        }

        return array.reduce(function (prev, next) {
          return deepmerge(prev, next, options);
        }, {});
      };

      var deepmerge_1 = deepmerge;
      module.exports = deepmerge_1;
      /***/
    },

    /***/
    152:
    /***/
    function (module) {
      function isUndefined(value) {
        return value === undefined;
      }

      function isNull(value) {
        return value === null;
      }

      function isBoolean(value) {
        return typeof value === 'boolean';
      }

      function isObject(value) {
        return value === Object(value);
      }

      function isArray(value) {
        return Array.isArray(value);
      }

      function isDate(value) {
        return value instanceof Date;
      }

      function isBlob(value, isReactNative) {
        return isReactNative ? isObject(value) && !isUndefined(value.uri) : isObject(value) && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.slice === 'function';
      }

      function isFile(value, isReactNative) {
        return isBlob(value, isReactNative) && typeof value.name === 'string' && (isObject(value.lastModifiedDate) || typeof value.lastModified === 'number');
      }

      function initCfg(value) {
        return isUndefined(value) ? false : value;
      }

      function serialize(obj, cfg, fd, pre) {
        cfg = cfg || {};
        fd = fd || new FormData();
        cfg.indices = initCfg(cfg.indices);
        cfg.nullsAsUndefineds = initCfg(cfg.nullsAsUndefineds);
        cfg.booleansAsIntegers = initCfg(cfg.booleansAsIntegers);
        cfg.allowEmptyArrays = initCfg(cfg.allowEmptyArrays);
        cfg.noFilesWithArrayNotation = initCfg(cfg.noFilesWithArrayNotation);
        cfg.dotsForObjectNotation = initCfg(cfg.dotsForObjectNotation);
        var isReactNative = typeof fd.getParts === 'function';

        if (isUndefined(obj)) {
          return fd;
        } else if (isNull(obj)) {
          if (!cfg.nullsAsUndefineds) {
            fd.append(pre, '');
          }
        } else if (isBoolean(obj)) {
          if (cfg.booleansAsIntegers) {
            fd.append(pre, obj ? 1 : 0);
          } else {
            fd.append(pre, obj);
          }
        } else if (isArray(obj)) {
          if (obj.length) {
            obj.forEach(function (value, index) {
              var key = pre + '[' + (cfg.indices ? index : '') + ']';

              if (cfg.noFilesWithArrayNotation && isFile(value, isReactNative)) {
                key = pre;
              }

              serialize(value, cfg, fd, key);
            });
          } else if (cfg.allowEmptyArrays) {
            fd.append(pre + '[]', '');
          }
        } else if (isDate(obj)) {
          fd.append(pre, obj.toISOString());
        } else if (isObject(obj) && !isBlob(obj, isReactNative)) {
          Object.keys(obj).forEach(function (prop) {
            var value = obj[prop];

            if (isArray(value)) {
              while (prop.length > 2 && prop.lastIndexOf('[]') === prop.length - 2) {
                prop = prop.substring(0, prop.length - 2);
              }
            }

            var key = pre ? cfg.dotsForObjectNotation ? pre + '.' + prop : pre + '[' + prop + ']' : prop;
            serialize(value, cfg, fd, key);
          });
        } else {
          fd.append(pre, obj);
        }

        return fd;
      }

      module.exports = {
        serialize: serialize
      };
      /***/
    },

    /***/
    527:
    /***/
    function (module, __unused_webpack_exports, __webpack_require__) {
      "use strict";

      function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
      }

      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }

      function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
      }

      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
      }

      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      }

      (function () {
        'use strict';

        var L = __webpack_require__(31);

        var corslite = __webpack_require__(716);

        var flexiblePolyline = __webpack_require__(366);

        var objectToFormData = __webpack_require__(152);

        var merge = __webpack_require__(36);

        L.Routing = L.Routing || {};
        L.Routing.Here = L.Class.extend({
          options: {
            serviceUrl: 'https://router.hereapi.com/v8/routes',
            timeout: 30 * 1000,
            noticesTypeAsRouteError: ['critical'],
            urlParameters: {},
            routeRestriction: {
              transportMode: 'car',
              routingMode: 'fast'
            }
          },
          initialize: function initialize(apiKey, options) {
            this._apiKey = apiKey;
            L.Util.setOptions(this, merge(options, this.options));
            this.options.urlParameters["return"] = ['polyline,summary,turnByTurnActions', this.options.urlParameters["return"]].filter(function (t) {
              return t;
            }).join(',');
          },
          route: function route(waypoints, callback, context, options) {
            var timedOut = false,
                wps = [],
                url,
                timer;
            options = options || {};
            url = this.buildRouteUrl(waypoints, options);
            timer = setTimeout(function () {
              timedOut = true;
              callback.call(context || callback, {
                status: -1,
                message: 'Here request timed out.'
              });
            }, this.options.timeout); // Let reference here, problem when reverse geocoding point took to long, didnt have name here

            wps = waypoints;
            return corslite(url, L.bind(function (err, resp) {
              var data;
              clearTimeout(timer);

              if (!timedOut) {
                if (!err) {
                  data = JSON.parse(resp.responseText);

                  this._routeDone(data, wps, callback, context);
                } else {
                  callback.call(context || callback, {
                    status: -1,
                    message: 'HTTP request failed: ' + err,
                    type: err.type
                  });
                }
              }
            }, this));
          },
          _routeDone: function _routeDone(response, inputWaypoints, callback, context) {
            var _this = this;

            context = context || callback;

            if (!response.routes || response.routes.length === 0) {
              callback.call(context, {
                // TODO: include all errors
                status: response.type,
                message: response.details
              });
              return;
            }

            if (this.options.noticesTypeAsRouteError) {
              var routeCriticalNotices = [];
              response.routes.forEach(function (route) {
                return route.sections.forEach(function (section) {
                  return (section.notices || []).forEach(function (notice) {
                    if (_this.options.noticesTypeAsRouteError.includes(notice.severity)) {
                      routeCriticalNotices.push(notice);
                    }
                  });
                });
              });

              if (routeCriticalNotices.length > 0) {
                callback.call(context, {
                  status: 'routeCriticalNotice',
                  message: routeCriticalNotices.map(function (notice) {
                    return notice.title;
                  }).join(';')
                });
                return;
              }
            }

            var roadsLabels = [];
            var callbackData = response.routes.map(function (route) {
              var defaultValue = {
                name: '',
                longestRoadLabels: [],
                coordinates: [],
                instructions: [],
                summary: {
                  totalDistance: 0,
                  totalTime: 0
                },
                inputWaypoints: inputWaypoints,
                waypoints: []
              };
              return route.sections.reduce(function (acc, section, index) {
                var _acc$coordinates, _acc$instructions;

                var offsetPadding = acc.coordinates.length;

                (_acc$coordinates = acc.coordinates).push.apply(_acc$coordinates, _toConsumableArray(flexiblePolyline.decode(section.polyline).polyline));

                acc.summary.totalDistance += section.summary.length;
                acc.summary.totalTime += section.summary.duration;

                if (index === 0) {
                  var waypoint = section.arrival.place.location;
                  acc.waypoints.push(new L.LatLng(waypoint.lat, waypoint.lng));
                }

                if (index === route.sections.length - 1 || index !== 0) {
                  var _waypoint = section.departure.place.location;
                  acc.waypoints.push(new L.LatLng(_waypoint.lat, _waypoint.lng));
                }

                var _this$_parseInstructi = _this._parseInstructions(section.turnByTurnActions, offsetPadding, roadsLabels),
                    instructions = _this$_parseInstructi.instructions,
                    roadLabels = _this$_parseInstructi.roadLabels;

                (_acc$instructions = acc.instructions).push.apply(_acc$instructions, _toConsumableArray(instructions));

                var roadNameSegments = roadLabels.map(function (label) {
                  return label.text;
                });
                acc.name = roadNameSegments.join(', ');
                roadsLabels.push(roadNameSegments);
                return acc;
              }, defaultValue);
            });
            callback.call(context, null, callbackData);
          },
          buildRouteUrl: function buildRouteUrl(waypoints, options) {
            var _this$options$transpo;

            var vehicleRestrictions = this._attachVehicleRestrictions(this.options);

            var mode = Object.keys(vehicleRestrictions).length > 0 ? 'truck' : (_this$options$transpo = this.options.transportMode) !== null && _this$options$transpo !== void 0 ? _this$options$transpo : 'car';
            var params = merge({
              apiKey: this._apiKey,
              transportMode: mode,
              routingMode: this.options.routeRestriction.routeMode || 'fast',
              departureTime: this.options.routeRestriction.trafficMode === false ? 'any' : null,
              avoid: {
                features: this._buildAvoidFeatures(this.options)
              },
              vehicle: vehicleRestrictions
            }, this.options.urlParameters);
            var locs = waypoints.reduce(function (acc, waypoint, i) {
              var paramName = i === 0 ? 'origin' : i === waypoints.length - 1 ? 'destination' : 'via';
              acc.push(paramName + '=' + waypoint.latLng.lat + ',' + waypoint.latLng.lng);
              return acc;
            }, []);
            var baseUrl = this.options.serviceUrl + '?' + locs.join('&');
            var formData = objectToFormData.serialize(params);

            _toConsumableArray(formData.keys()).forEach(function (key) {
              if (!formData.get(key)) {
                formData["delete"](key);
              }
            });

            return baseUrl + '&' + new URLSearchParams(formData).toString();
          },
          _buildAvoidFeatures: function _buildAvoidFeatures(options) {
            var features = [];

            if (!options.hasOwnProperty('routeRestriction')) {
              return null;
            }

            if (options.routeRestriction.avoidHighways === true) {
              features.push('controlledAccessHighway');
            }

            if (options.routeRestriction.avoidTolls === true) {
              features.push('tollRoad');
            }

            if (options.routeRestriction.avoidFerries === true) {
              features.push('ferry');
            }

            if (options.routeRestriction.avoidDirtRoad === true) {
              features.push('dirtRoad');
            }

            return features.join(',');
          },
          _attachVehicleRestrictions: function _attachVehicleRestrictions(options) {
            var _truckRestrictions = {};
            var allowedParameters = ['height', 'width', 'length', 'grossWeight', 'weightPerAxle', 'shippedHazardousGoods', 'trailerCount'];

            if (!options.hasOwnProperty('routeRestriction') || !options.hasOwnProperty('truckRestriction') || options.routeRestriction.transportMode !== 'truck') {
              return _truckRestrictions;
            }

            if (options.truckRestriction.hasOwnProperty('shippedHazardousGoods')) {
              if (Array.isArray(options.truckRestriction['shippedHazardousGoods'])) {
                options.truckRestriction['shippedHazardousGoods'] = options.truckRestriction['shippedHazardousGoods'].join();
              }
            }

            for (var property in options.truckRestriction) {
              if (!options.truckRestriction.hasOwnProperty(property) || allowedParameters.indexOf(property) === -1 || options.truckRestriction[property] === '' || options.truckRestriction[property] === null) {
                continue;
              }

              _truckRestrictions[property] = options.truckRestriction[property];
            }

            _truckRestrictions.type = 'straightTruck';
            return _truckRestrictions;
          },
          _parseInstructions: function _parseInstructions(instructions, offsetPadding, existingRoadNameSegments) {
            var _this2 = this;

            return instructions.reduce(function (acc, instruction) {
              var _instruction$directio;

              if (instruction.nextRoad && (instruction.nextRoad.name || instruction.nextRoad.number)) {
                var roadLabel = {
                  index: instruction.offset + offsetPadding,
                  length: instruction.length,
                  text: _this2._getInstructionRoadLabel(instruction)
                };
                var labelExists = acc.roadLabels.find(function (label) {
                  return label.text === roadLabel.text;
                });

                if (!labelExists && acc.roadLabels.length < 2) {
                  if (!acc.roadLabels[0] || !_this2._labelCombinationSegmentExists(existingRoadNameSegments, [acc.roadLabels[0].text, roadLabel.text])) {
                    acc.roadLabels.push(roadLabel);
                  }
                } else if (!labelExists) {
                  var shortestInstructionIndex = acc.roadLabels.findIndex(function (i) {
                    return i.length < instruction.length;
                  });
                  var newLabels = [].concat(_toConsumableArray(acc.roadLabels.filter(function (_, index) {
                    return index !== shortestInstructionIndex;
                  }).map(function (i) {
                    return i.text;
                  })), [roadLabel.text]);

                  var combinationExists = _this2._labelCombinationSegmentExists(existingRoadNameSegments, newLabels);

                  if (shortestInstructionIndex >= 0 && !combinationExists) {
                    acc.roadLabels[shortestInstructionIndex] = roadLabel;
                    acc.roadLabels.sort(function (a, b) {
                      return a.index - b.index;
                    });
                  }
                }
              }

              acc.instructions.push({
                text: "".concat(instruction.action, " ").concat((_instruction$directio = instruction.direction) !== null && _instruction$directio !== void 0 ? _instruction$directio : ''),
                distance: instruction.length,
                time: instruction.duration,
                index: offsetPadding + instruction.offset,
                type: instruction.action
              });
              return acc;
            }, {
              instructions: [],
              roadLabels: []
            });
          },
          _getInstructionRoadLabel: function _getInstructionRoadLabel(instruction) {
            var _instruction$nextRoad;

            var r = (_instruction$nextRoad = instruction.nextRoad.number) !== null && _instruction$nextRoad !== void 0 ? _instruction$nextRoad : instruction.nextRoad.name;
            return r ? r[0].value : '';
          },
          _labelCombinationSegmentExists: function _labelCombinationSegmentExists(segments, combinationSegments) {
            return segments.some(function (roadSegment) {
              return roadSegment.every(function (segment) {
                return combinationSegments.includes(segment);
              });
            });
          }
        });

        L.Routing.here = function (apiKey, options) {
          return new L.Routing.Here(apiKey, options);
        };

        module.exports = L.Routing.Here;
      })();
      /***/

    },

    /***/
    31:
    /***/
    function (module) {
      "use strict";

      module.exports = L;
      /***/
    }
    /******/

  };
  /************************************************************************/

  /******/
  // The module cache

  /******/

  var __webpack_module_cache__ = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/
    // Check if module is in cache

    /******/
    var cachedModule = __webpack_module_cache__[moduleId];
    /******/

    if (cachedModule !== undefined) {
      /******/
      return cachedModule.exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = __webpack_module_cache__[moduleId] = {
      /******/
      // no module.id needed

      /******/
      // no module.loaded needed

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/

    /******/
    // Return the exports of the module

    /******/


    return module.exports;
    /******/
  }
  /******/

  /************************************************************************/

  /******/

  /******/
  // startup

  /******/
  // Load entry module and return exports

  /******/
  // This entry module is referenced by other modules so it can't be inlined

  /******/


  var __webpack_exports__ = __webpack_require__(527);
  /******/

  /******/

})();